import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { generatePath } from 'react-router'

import filterSideListHOC from '../wrappers/withFilterSideList'

import { DataTable } from 'components/DataTable'
import { Modal } from 'components/Modal'
import NewMessage from '../fragments/NewMessageComponent'
import CashRegisterTree from 'components/CashRegisterTree'
import ContentHeader from 'components/ContenHeader'
import { getMaxTableHeight } from '../helpers'
import { allMessages, userList } from '../tableColumns'
import { listClientMessage, listUsers } from '../gql'

import tableStyle from '../../../components/DataTable/DataTable.module.scss'

const SideListWrapper = ({ children, FilterBtn, FilterWindow, filterValues, multiEdit = {}, getRowData, ...props }) => {
	const [t] = useTranslation()
	const [showModal, setShowModal] = useState(false)
	const { history, selectRecord, isNewRecord, recordId, listQueryRef, appData, section, onCompleted } = props
	const selectedRecordId = isNewRecord ? null : recordId

	const getTableHeight = useCallback(() => getMaxTableHeight('allMessagesTable'))

	const headerTitle = () => {
		switch (filterValues?.isForShop) {
			case true: return t('message_section.strings.cashregister_messages')
			case false: return t('message_section.strings.users_messages')
			default: return t('message_section.strings.all_messages')
		}
	}

	const handleRowClick = (tableProps, { original }) => {
		if (multiEdit.isActive) {
			return multiEdit.handleSelectRecord(original.id)
		}

		if(filterValues?.isForShop === false) {
			getRowData(original.id, original.name)
		}

		selectRecord(original.id)
	}

	const handleSelect = ({ id, name }) => {
		// __typename only Shop
		getRowData(id, name)
		const path = generatePath(`/${section}/filiale/:id`, { id })
		history.push({
			pathname: path
		})
	}

	const renderSidelListComponent = () => {
		switch (filterValues?.isForShop) {
			case true:
				return(
					<CashRegisterTree
						isSelectable={{ __typename: 'Shop' }}
						isCheckable={false}
						showLeafCount={false}
						cardsInRow={1}
						startConcealed={false}
						hideNoCRBranches={false}
						height='80vh'
						onSelect={handleSelect}
					/>
				)
			case false:
				return(
					<DataTable
						onAddRecord={() => setShowModal(true)}
						selectRow={{
							selected: selectedRecordId,
							setSelectedRecord: () => null
						}}
						withSearch
						onRowClick={handleRowClick}
						remoteOptions={{
							query: listUsers,
							rowMenu: [],
							withSearch: true
						}}
						columns={userList(t)}
						height={getTableHeight}
						defaultSorted={[
							{
								id: 'code',
								desc: false
							}
						]}
					/>
				)
			default:
				return (
					<DataTable
						id='allMessagesTable'
						onAddRecord={() => setShowModal(true)}
						selectRow={{
							selected: selectedRecordId,
							setSelectedRecord: selectRecord
						}}
						onRowClick={handleRowClick}
						withSearch
						remoteOptions={{
							queryRef: listQueryRef,
							query: listClientMessage,
							rowMenu: [],
							withSearch: true,
							withSort: true,
							onCompleted: onCompleted
						}}
						height={getTableHeight}
						columns={allMessages(t)}
						defaultSorted={[
							{
								id: 'createdAt',
								desc: true
							}
						]}
					/>
				)
		}
	}

	return(
		<>
			<div className={classNames(tableStyle.root, { [tableStyle.insideContentBlock]: true })}>
				<ContentHeader
					rightCol={<>{FilterBtn}</>}
					title={headerTitle()}
				/>
				<div className={tableStyle.tableBody}>
					{renderSidelListComponent()}
					{children}
					{FilterWindow}
				</div>
			</div>
			{showModal &&
				<Modal label={t('message_section.strings.new_message')} width={1000} unmount={() => setShowModal(null)}>
					<NewMessage appData={appData} listQueryRef={listQueryRef} onClose={() => setShowModal(null)}/>
				</Modal>
			}
		</>
	)
}

export default filterSideListHOC(SideListWrapper)

